<script>
import {mapActions, mapState} from "pinia";
import {editProposalStore} from "@/store/editProposalStore";
import {argumentStore} from "@/store/argumentStore";
import ArgumentNewItem from "@/views/arguments/ArgumentNewItem.vue";

export default {
  name: "EditProposalArguments",
  components: {
    ArgumentNewItem
  },
  data() {
    return {
      readyForSave: true
    }
  },
  computed: {
    ...mapState(editProposalStore, [
      'editedProposalData',
      'editedProposalArguments'
    ]),
    allowCreateNewArg() {
      return this.editedProposalArguments.length < 10;
    }
  },
  methods: {
    ...mapActions(editProposalStore, [
      'addNewArgument',
      'removeProposalArgument',
      'setAsModified',
      'initAutoSave',
    ]),
    ...mapActions(argumentStore, [
        'getArguments'
    ]),
    removeArg(argIndex) {
      this.removeProposalArgument(argIndex);
      this.setAsModified('proposalArgumentsChanged', true);
      this.initAutoSave('ARGUMENT');
    },
    updateArgData(argIndex, data) {
      const activeArg = this.editedProposalArguments[argIndex];

      activeArg.title = data.title;
      activeArg.type = data.type;
      activeArg.order = data.order;
      if (activeArg.type === 'VIDEO') {
        activeArg.attachedVideoDoc = data.attachedVideoDoc;
      } else if (activeArg.type === 'TEXT') {
        activeArg.argText = data.argText ? data.argText : '';
      }

      activeArg.changedTitle = data.changedTitle;
      activeArg.changedContent = data.changedContent;

      this.setAsModified('proposalArgumentsChanged', true);
      this.initAutoSave('ARGUMENT');
    },
    validateArguments() {
      const $arguments = this.$refs.argumentNewItem || [];

      this.readyForSave = true;
      if ($arguments.length > 0) {
        $arguments.forEach((arg) => {
          arg.validateArg();
          if (arg.v$.$invalid) {
            this.readyForSave = false;
          }
        })
      }
    }
  }
}
</script>

<template>
  <div class="edit-prop-section arguments-section">
    <span class="edit-prop-section__title arguments-section__title">
      2. Your arguments
    </span>
    <div class="arguments-list">
      <argument-new-item v-for="(arg, index) in editedProposalArguments"
                         :key="index"
                         :arg-index="index"
                         :arg-data="arg"
                         :can-be-removed="editedProposalArguments.length > 1"
                         @on-update="updateArgData"
                         @on-remove="removeArg"
                         ref="argumentNewItem"
      />
    </div>
    <div v-if="allowCreateNewArg" class="add-arg-control" @click="addNewArgument">
      <font-awesome-icon :icon="['fas', 'circle-plus']" class="add-arg-control__icon" />
      <span class="add-arg-control__text">Add next argument</span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.arguments-section {
  display: flex;
  flex-direction: column;
  min-height: 320px;

  &__title {
    font-size: 16px;
    font-weight: 600;
    color: #4f4f4f;
    padding: 15px 0;
    border-bottom: solid 1px rgba(79, 79, 79, 0.15);
    margin: 0 0 10px;
  }

  .add-arg-control {
    cursor: pointer;
    &__icon {
      margin-right: 5px;
      font-size: 14px;
      color: #7835a6;
    }
    &__text {
      font-size: 14px;
      font-weight: 600;
      color: #7835a6;
    }
  }
}
</style>